export default __webpack_public_path__ + "static/EmployerBackground2024-2cf92ce3fd8c2468d7c43f998c66b43a.jpg";